// populateFields populates fields recursively
// eg: populateFields(fields, { keyOne: valueOne, keyTwo: valueTwo })
export const populateFields = (fields: any[], data: any, isUnlink?: boolean ) => {
  fields.forEach((field: any) => {
    if (field.type !== "asset" ) {
      Object.keys(data).forEach((key: string) => {
        field[key] = data[key]
      })
    } else {
      if (isUnlink) {
        field.parentAssetId = null
      }
    }
    if(field.fields) {
      populateFields(field.fields, data)
    }
  })
}

// deleteFields deletes fields recursively
// eg: deleteFields(fields, [keyOne, keyTwo])
export const deleteFields = (fields: any[], delField: string[]) => {
  fields.forEach((field: any) => {
    delField.forEach(el => delete field[el])
    if(field.fields) {
      deleteFields(field.fields, delField)
    }
  })
}
